import { isObjectEmpty, isFullArray } from "_utils/functions";

// check if the variable is object and is empty
Object.isObjectEmpty = isObjectEmpty;

// check if the variable is Array and is not empty
Array.isFullArray = isFullArray;
